exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dialog{box-sizing:border-box;color:#353b44;font-family:Arial,Helvetica,sans-serif;font-size:15px;transition:opacity .1s ease-in-out}dialog.initializing{opacity:0}dialog *{box-sizing:border-box}dialog::-webkit-backdrop{background-color:rgba(48,56,64,.75)}dialog::backdrop{background-color:rgba(48,56,64,.75)}dialog+.backdrop{background-color:rgba(48,56,64,.75)}", ""]);

// exports
